export const APPROVED_OPTIONS = [
  {
    value: '',
    label: 'All',
  },
  {
    value: 'true',
    label: 'Approved',
  },
  {
    value: 'false',
    label: 'Not Approved',
  },
]
